import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';

import {
  GET_SHOP_BUTTON_REQUEST,
  GET_SHOP_BUTTON_SUCCESS,
  GET_SHOP_BUTTON_FAILURE,
  COMMON_FAILURE,
} from '../../actions';
import { shopButtonService } from '../../services';
import { historyType } from '../../../utils/commonType';

export type getShopButtonAction = {
  type: typeof GET_SHOP_BUTTON_REQUEST;
  shopId: string;
  buttonId: string;
  history: historyType;
};

function* getShopButton(action: getShopButtonAction): Generator<unknown> {
  try {
    const res: any = yield call(shopButtonService(action).getShopButton);
    yield put({
      type: GET_SHOP_BUTTON_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_SHOP_BUTTON_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchShopButton() {
  yield takeLatest(GET_SHOP_BUTTON_REQUEST, getShopButton);
}

export default function* shopButtonSaga(): Generator<unknown> {
  yield all([fork(watchShopButton)]);
}
